import { useCallback } from 'react';

import { actions, useAppDispatch } from 'state/global-state';
import { RewardRedemptionMethod } from 'state/loyalty/hooks/types';

export const useLoyaltyUserStateCleanup = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(actions.loyalty.setUser(null));
    dispatch(actions.loyalty.resetAppliedOffers());
    dispatch(actions.loyalty.setSelectedOffer(null));
    dispatch(actions.loyalty.resetOfferFeedbackMap());
    dispatch(
      actions.loyalty.resetLoyaltyRewardsState({
        points: 0,
        redemptionMethod: RewardRedemptionMethod.MOBILE,
      })
    );
    dispatch(actions.loyalty.resetNotificationCenterSession(null));
  }, [dispatch]);
};
